import { connect } from 'react-redux';

import { isUserLoggedIn } from 'apps/user/helpers';
import SearchSuggestions from 'apps/header/components/SearchSuggestions';

export default connect(
  state => ({
    isLoggedIn: isUserLoggedIn(state.user),
    selectedSearchSuggestion: state.header.search.selectedSearchSuggestion,
  })
)(SearchSuggestions);

